var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayContentCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "play-completed-title"
  }, "Content completed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "play-completed-title"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#00865E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6252 22.8691V33.13L32.4189 27.9995L23.6252 22.8691ZM21.8052 18.4329L37.1293 27.3725C37.2392 27.4367 37.3302 27.5287 37.3935 27.639C37.4568 27.7494 37.4901 27.8745 37.4901 28.0017C37.4901 28.129 37.4568 28.254 37.3935 28.3644C37.3302 28.4748 37.2392 28.5667 37.1293 28.631L21.8052 37.5706C21.694 37.6354 21.5677 37.6697 21.4391 37.67C21.3104 37.6702 21.1839 37.6364 21.0726 37.572C20.9612 37.5075 20.8688 37.4148 20.8049 37.3031C20.741 37.1915 20.7077 37.0649 20.7085 36.9362V19.0614C20.7085 18.9331 20.7423 18.8071 20.8065 18.696C20.8708 18.585 20.9632 18.4928 21.0745 18.4289C21.1857 18.365 21.3119 18.3316 21.4402 18.332C21.5685 18.3325 21.6944 18.3668 21.8052 18.4314V18.4329Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayContentCompleted);
export default ForwardRef;